import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getProductivityRiskKPI';

export const getProductivityRiskKPI = (params) => {
    return network.post(ENDPOINT, params).then((response) => response.data);
};
